import styles from "./Tooltip.module.css";
import tooltipIcon from "../../../assets/tooltip-icon.svg";
import classNames from "classnames";

const strings = {
  info: "Info",
};

export type TooltipVariant = "long" | "short";

export type TooltipProps = {
  className?: string;
  variant?: TooltipVariant;
  header?: React.ReactNode;
  children: React.ReactNode;
  footer?: React.ReactNode;
};

export default function Tooltip({
  header,
  footer,
  className,
  children,
  variant = "long",
}: TooltipProps) {
  // If children is empty (likely an empty string), do not display tooltip
  if (!children) {
    return null;
  }
  return (
    <div className={classNames(styles.container, className)}>
      <img src={tooltipIcon} alt={strings.info} />
      <div
        className={classNames(styles.content, {
          [styles.short]: variant === "short",
        })}
      >
        {header && <div className={styles.header}>{header}</div>}
        <div
          className={classNames(styles.main, {
            [styles.short]: variant === "short",
          })}
        >
          {children}
        </div>
        {footer && <div className={styles.footer}>{footer}</div>}
      </div>
    </div>
  );
}
